export default {
  domain: window.config.domain,
  websocket:  window.config.websocket
}
